(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-earrings"] && !Shopify.designMode) return;
  try {
    (function(){
  var $ = function(s,c){ return (c||document).querySelector(s); };
  var $$ = function(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); };

  function fmt(cents){
    return new Intl.NumberFormat('en-US',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'USD'}).format(cents/100);
  }

  function initBlock(id){
    var root = document.getElementById('pi-'+id);
    if(!root||root.dataset.ready) return;
    root.dataset.ready='1';

    var variants = JSON.parse(document.getElementById('pi-data-'+id).textContent);
    var inputs   = $$('.pi-input', root);
    var numOpts  = $$('.pi-opt', root).length;

    var vMap = {};
    variants.forEach(function(v){ vMap[v.options.join('|')] = v; });

    function getSelections(){
      var r=[];
      for(var i=0;i<numOpts;i++){
        var el = root.querySelector('.pi-input[data-idx="'+i+'"]:checked');
        r.push(el ? el.value : '');
      }
      return r;
    }

    function findVariant(sels){ return vMap[sels.join('|')]||null; }

    function updatePrice(v){
      var priceEl   = document.getElementById('pi-price-'+id);
      var compareEl = document.getElementById('pi-compare-'+id);
      var saveEl    = document.getElementById('pi-save-'+id);
      var dealEl    = document.getElementById('pi-deal-'+id);
      var badgeEl = document.getElementById('pi-badge-'+id);
if(badgeEl){
  if(v.compare_at_price > v.price){
    badgeEl.textContent = Math.round((v.compare_at_price - v.price)*100/v.compare_at_price) + '% OFF';
    badgeEl.style.display = '';
  } else {
    badgeEl.style.display = 'none';
  }
}
      if(!v){
        if(priceEl) priceEl.textContent='Unavailable';
        return;
      }
      if(priceEl)  priceEl.textContent = fmt(v.price);
      if(dealEl)   dealEl.textContent  = fmt(v.price*0.80);
      if(compareEl){
        if(v.compare_at_price > v.price){
          compareEl.textContent = fmt(v.compare_at_price);
          compareEl.style.display='';
          if(saveEl){ saveEl.textContent='Save '+fmt(v.compare_at_price-v.price); saveEl.style.display=''; }
         
          
        } else {
          compareEl.style.display='none';
          if(saveEl) saveEl.style.display='none';
        }
      }
    }

    function refreshActive(){
      inputs.forEach(function(inp){
        var lbl = inp.closest('.pi-btn,.pi-swatch-wrap');
        if(lbl) lbl.classList.toggle('is-active', inp.checked);
      });
      var metalEl = document.getElementById('pi-metal-'+id);
      if(metalEl){
        var m = root.querySelector('.pi-swatch-wrap input:checked');
        if(m) metalEl.textContent = m.value;
      }
    }

    function refreshAvailability(sels){
      for(var i=0;i<numOpts;i++){
        $$('.pi-input[data-idx="'+i+'"]', root).forEach(function(inp){
          var test=sels.slice(); test[i]=inp.value;
          var v=findVariant(test);
          var lbl=inp.closest('.pi-btn,.pi-swatch-wrap');
          if(lbl) lbl.classList.toggle('is-soldout', !v||!v.available);
        });
      }
    }

    function bridgeTheme(variant, sels){
      if(!variant) return;
      sels.forEach(function(val,i){
        var inp = root.querySelector('.pi-input[data-idx="'+i+'"]');
        var name = inp ? inp.dataset.name : '';
        var sel = document.querySelector('select[name="options['+name+']"]');
        if(sel && sel.value!==val){ sel.value=val; sel.dispatchEvent(new Event('change',{bubbles:true})); }
        var rad = document.querySelector('input[type="radio"][name="options['+name+']"][value="'+CSS.escape(val)+'"]');
        if(rad && !rad.checked){ rad.checked=true; ['change','input'].forEach(function(e){ rad.dispatchEvent(new Event(e,{bubbles:true})); }); }
      });
      $$('variant-radios, variant-selects').forEach(function(comp){
        sels.forEach(function(val,i){
          var r=comp.querySelector('input[type="radio"][value="'+CSS.escape(val)+'"]');
          if(r&&!r.checked){ r.checked=true; r.dispatchEvent(new Event('change',{bubbles:true})); }
          var s=comp.querySelector('select:nth-of-type('+(i+1)+')');
          if(s&&s.value!==val){ s.value=val; s.dispatchEvent(new Event('change',{bubbles:true})); }
        });
      });
      $$('product-form, form[action="/cart/add"]').forEach(function(form){
        var hidden=form.querySelector('input[name="id"]');
        if(hidden&&hidden.value!==String(variant.id)){ hidden.value=variant.id; hidden.dispatchEvent(new Event('change',{bubbles:true})); }
      });
      document.dispatchEvent(new CustomEvent('variant:changed',{bubbles:true,detail:{variant:variant,variant_id:variant.id}}));
      if(window.history&&window.history.replaceState){
        var u=new URL(window.location.href);
        u.searchParams.set('variant',variant.id);
        window.history.replaceState({},'',u.toString());
      }
    }

    function onChange(){
      refreshActive();
      var sels=getSelections();
      var v=findVariant(sels);
      refreshAvailability(sels);
      updatePrice(v);
      bridgeTheme(v,sels);
    }

    inputs.forEach(function(inp){ inp.addEventListener('change',onChange); });
    onChange();
  }

  function initAll(){
    $$('[id^="pi-"]').forEach(function(el){
      var m=el.id.match(/^pi-([^-].*)$/);
      if(m) initBlock(m[1]);
    });
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAll);
  else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
